// src/client/lib/client-config.ts
// Client-specific runtime configuration
// Imports shared constants and adds browser-specific runtime detection

import {
  SUB_PATH,
  PROJECT_PATH,
  BASE_PATH,
  API_BASE,
  APP_CONFIG,
  VALIDATION,
  DEFAULTS,
  FEATURES,
  USERSCRIPT_CONFIG,
  USERSCRIPT_DOWNLOAD_ENDPOINT,
  USERSCRIPT_VERSION,
  USERSCRIPT_TEMPLATE_NAME,
  USERSCRIPT_MATCHES,
  USERSCRIPT_GRANTS,
  USERSCRIPT_UUID
} from './shared/config';

// ============================================================================
// Re-export all shared constants
// ============================================================================

export {
  SUB_PATH,
  PROJECT_PATH,
  BASE_PATH,
  API_BASE,
  APP_CONFIG,
  VALIDATION,
  DEFAULTS,
  FEATURES,
  USERSCRIPT_CONFIG,
  USERSCRIPT_DOWNLOAD_ENDPOINT,
  USERSCRIPT_VERSION,
  USERSCRIPT_TEMPLATE_NAME,
  USERSCRIPT_MATCHES,
  USERSCRIPT_GRANTS,
  USERSCRIPT_UUID
};

// ============================================================================
// Browser-specific Runtime Detection
// ============================================================================

export const IS_DEVELOPMENT = false;  //process.env.NODE_ENV === 'development';  //import.meta.env.DEV;
export const IS_PRODUCTION = true;  //process.env.NODE_ENV === 'production';
const PRODUCTION_HOST= "https://spaces.kongressmedia.de";

// ============================================================================
// Client-specific Feature Flags
// ============================================================================

export const CLIENT_FEATURES = {
  debugMode: IS_DEVELOPMENT,
  devTools: IS_DEVELOPMENT,
  verboseLogging: IS_DEVELOPMENT,
  showQueryDevTools: IS_DEVELOPMENT,
} as const;

export const HOST_URL = PRODUCTION_HOST;